import { useMemo, useEffect, useState, useCallback } from "react";
import { useImperativeModal } from "ImperativeModalProvider";
import { useApi } from "providers/ApiProvider";
import Icon from "~/components/Icon";
import SelectSignRequestDoctorModal from "./SelectSignRequestDoctorModal";
import { Box, Stack } from "./SignRequestDoctorButton.styled";

interface SignRequestDoctorButtonProps {
  signRequestDoctorId: null | number;
  setSignRequestDoctorId: (id: number) => void;
}

const SignRequestDoctorButton = ({
  signRequestDoctorId,
  setSignRequestDoctorId,
}: SignRequestDoctorButtonProps) => {
  const { userApi } = useApi();
  const imperativeModal = useImperativeModal();
  const [doctors, setDoctors] = useState([]);

  const loadDoctors = useCallback(async () => {
    const res = await userApi.getUserDuty({
      limit: 300,
      userStatus: "active",
    });
    const payload = await res.data;
    payload.data && setDoctors(payload.data);
  }, []);

  useEffect(() => {
    loadDoctors();
  }, []);

  const options = useMemo(() => {
    return [
      { id: 0, label: "없음" },
      ...doctors
        .filter((f: any) => f.certificate !== null)
        .map((d: any) => ({ id: d.id, label: d.name ?? "" })),
    ];
  }, [doctors]);

  const signReuqestDoctorName = useMemo(() => {
    return signRequestDoctorId
      ? options.find((f) => f.id === signRequestDoctorId)?.label
      : "없음";
  }, [signRequestDoctorId, options]);

  const handleOpenSelectDoctorPopup = async () => {
    const selected: any = await imperativeModal.open((close) => (
      <SelectSignRequestDoctorModal
        doctors={options}
        signRequestDoctorId={signRequestDoctorId}
        onClose={close}
      />
    ));
    if (selected) {
      setSignRequestDoctorId(selected.id);
    }
  };

  return (
    <Box className="certificate-button" onClick={handleOpenSelectDoctorPopup}>
      <Stack flexDirection="row" alignItems="center" gap="2px">
        <span className="label">전자서명 요청 : </span>
        <Box className="doctor-name">{signReuqestDoctorName}</Box>
      </Stack>
      <Icon variant="chevron_right" />
    </Box>
  );
};

export default SignRequestDoctorButton;
